export const secondaryButtonStyle = {
  padding: '10px 20px',
  height: 'auto',
};

export const actionButtonStyle = {
  padding: '10px 20px',
  height: 'auto',
  background:'#002136',
  border:'none'
}

export const navReturnBtnStyle ={
  padding: '10px 20px',
  height: 'auto',
  background:'#fff',
  border: '1px solid #002136'
}
